// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./+not-found.tsx": { enumerable: true, get() { return import("/Users/toni/Projects/bokbok-tv/src/app/+not-found.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return import("/Users/toni/Projects/bokbok-tv/src/app/_layout.tsx"); } },
  "./hr/index.tsx": { enumerable: true, get() { return import("/Users/toni/Projects/bokbok-tv/src/app/hr/index.tsx"); } },
  "./hr/my-account.tsx": { enumerable: true, get() { return import("/Users/toni/Projects/bokbok-tv/src/app/hr/my-account.tsx"); } },
  "./hr/video-chat.tsx": { enumerable: true, get() { return import("/Users/toni/Projects/bokbok-tv/src/app/hr/video-chat.tsx"); } },
  "./hr/video-settings.tsx": { enumerable: true, get() { return import("/Users/toni/Projects/bokbok-tv/src/app/hr/video-settings.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return import("/Users/toni/Projects/bokbok-tv/src/app/index.tsx"); } },
  "./index.web.tsx": { enumerable: true, get() { return import("/Users/toni/Projects/bokbok-tv/src/app/index.web.tsx"); } },
  "./login.ios.tsx": { enumerable: true, get() { return import("/Users/toni/Projects/bokbok-tv/src/app/login.ios.tsx"); } },
  "./login.tsx": { enumerable: true, get() { return import("/Users/toni/Projects/bokbok-tv/src/app/login.tsx"); } },
  "./my-account.tsx": { enumerable: true, get() { return import("/Users/toni/Projects/bokbok-tv/src/app/my-account.tsx"); } },
  "./video-chat.tsx": { enumerable: true, get() { return import("/Users/toni/Projects/bokbok-tv/src/app/video-chat.tsx"); } },
  "./video-settings.tsx": { enumerable: true, get() { return import("/Users/toni/Projects/bokbok-tv/src/app/video-settings.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;